import React, { useState } from 'react';
import { useGetLandlordPropertyQuery } from '../../../app/lib/apiSlice/property/propertySlice.tsx';
import { useNavigate } from 'react-router-dom';

export default function TopMetrics() {
    const [selectedProperty, setSelectedProperty] = useState('all');
    const [selectedReport, setSelectedReport] = useState('All Reports');
    const [showNotification, setShowNotification] = useState(false);
    const navigate = useNavigate();

    const handlePropertyChange = (e) => {
        setSelectedProperty(e.target.value);
        setShowNotification(false); // Hide notification when user makes a selection
    };

    const handleReportChange = (e) => {
        setSelectedReport(e.target.value);
        setShowNotification(false); // Hide notification when user makes a selection
    };

    const { data: properties } = useGetLandlordPropertyQuery();

    const handleFilterClick = () => {
        // Check if both property and specific report are selected
        if (selectedReport === 'All Reports' || !selectedProperty) {
            setShowNotification(true);
            return;
        }

        // Map report types to their corresponding routes
        const reportRoutes = {
            'Occupancy Reports': '/occupancy-report/',
            'Rent Income Report': '/income-report/',
            'Payments Reports': '/payment-report/',
            'Deposits Reports': '/deposit-report/',
            'Utilities Reports': '/utility-report/',
            'Failed Reconciliation Reports': '/failed-report/',
            'Overpayment Reports': '/overpayment-report/',
            'System Administrators Reports': '/owner-report/',
            'Tenants Feedback Reports': '/tenants-feedback/',
            // 'Unpaid Invoices Reports': '/payments-updates/'
        };

        const route = reportRoutes[selectedReport];
        if (route) {
            navigate(`${route}${selectedProperty}`);
        }
    };

    // Determine if button should be disabled
    const isButtonDisabled = selectedReport === 'All Reports' || !selectedProperty;

    return (
        <div className="bg-white shadow-lg p-6 rounded-xl">
            <div className="flex md:flex-row flex-col md:justify-between md:items-center gap-4 mb-4">
                <h5 className='font-bold text-lg'>Get Detailed Report</h5>
            </div>

            {/* Notification */}
            {showNotification && (
                <div className="bg-yellow-50 mb-4 p-3 border-yellow-400 border-l-4 rounded text-yellow-700">
                    <div className="flex items-center">
                        <svg className="mr-2 w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        <p className="text-sm">
                            Please select both a property and a specific report type to view detailed data.
                        </p>
                    </div>
                </div>
            )}

            <div className="gap-4 grid grid-cols-1 md:grid-cols-3">
                {/* Property Selector */}
                <div className="space-y-1">
                    <select
                        className="bg-white hover:bg-gray-50 shadow-sm px-3 py-2 border border-gray-300 focus:border-indigo-500 rounded-lg focus:ring-indigo-500 w-full text-sm transition-colors"
                        value={selectedProperty}
                        onChange={handlePropertyChange}
                    >
                        <option value="all">All Properties</option>
                        {properties?.results?.map((property) => (
                            <option key={property.id} value={property.id}>{property.name}</option>
                        ))}
                    </select>
                </div>

                {/* Report Type */}
                <div className="space-y-1">
                    <select
                        className="bg-white hover:bg-gray-50 shadow-sm px-3 py-2 border border-gray-300 focus:border-indigo-500 rounded-lg focus:ring-indigo-500 w-full text-sm transition-colors"
                        value={selectedReport}
                        onChange={handleReportChange}
                    >
                        <option>All Reports</option>
                        <option>Occupancy Reports</option>
                        <option>Rent Income Report</option>
                        <option>Payments Reports</option>
                        <option>Deposits Reports</option>
                        <option>Utilities Reports</option>
                        <option>Failed Reconciliation Reports</option>
                        <option>Overpayment Reports</option>
                        <option>System Administrators Reports</option>
                        <option>Tenants Feedback Reports</option>
                        {/* <option>Unpaid Invoices Reports</option> */}
                    </select>
                </div>

                {/* Get the report button */}
                <button
                    onClick={handleFilterClick}
                    disabled={isButtonDisabled}
                    className={`float-end flex justify-center items-center shadow-sm px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 w-50 md:w-auto font-medium text-white text-sm transition-colors ${
                        isButtonDisabled 
                            ? 'bg-gray-400 cursor-not-allowed' 
                            : 'bg-purple-600 hover:bg-purple-700'
                    }`}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="mr-2 w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                    </svg>
                    Get Detailed Report
                </button>
            </div>
        </div>
    );
}
